import { User } from "../types/types";

export const isUserRegistered = (user: User) => {
  if (!user?.profile?.customer_account_id || !user?.profile?.customer_contact_id) return false;

  return user.profile.customer_account_id > 0 && user.profile.customer_contact_id > 0;
};
